<template>
    <div class="table-btn-col name-number-table-wrap">
        <div v-if="normalizedRows.length > 0 && showExport" class="data-export-btn">
            <a class="export-btn btn btn_outline_primary buttons" href="javascript:;" @click="downloadCsv">
                Export
            </a>
        </div>

        <table v-if="normalizedRows.length > 0" class="name-number-data">
            <tr class="cart-data-col">
                <th v-if="hasName" class="data-heading">Name</th>
                <th v-if="hasNumber" class="data-heading">Number</th>
                <th class="data-heading">Size</th>
            </tr>
            <tr v-for="(row, key) in normalizedRows" :key="key" class="cart-data-col">
                <td v-if="hasName">{{ row.name }}</td>
                <td v-if="hasNumber">{{ row.number }}</td>
                <td>{{ row.size }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: "NameNumberTable",
    props: {
        rows: {
            type: Array,
            required: true
        },
        showExport: {
            type: Boolean,
            required: false,
            default: true
        },
        csvFileName: {
            type: String,
            required: false,
            default: "NameAndNumber.csv"
        },
        csvHeader: {
            type: String,
            required: false,
            default: "Name,Number,Size\n"
        }
    },
    computed: {
        normalizedRows() {
            if (!this.rows || !Array.isArray(this.rows)) return [];
            return this.rows.map((r) => ({
                name: r && r.name != null ? String(r.name) : "",
                number: r && r.number != null ? String(r.number) : "",
                size: r && r.size != null ? String(r.size) : ""
            }));
        },
        hasName() {
            return this.normalizedRows.some((r) => String(r.name || "").trim() !== "");
        },
        hasNumber() {
            return this.normalizedRows.some((r) => String(r.number || "").trim() !== "");
        }
    },
    methods: {
        downloadCsv() {
            const rows = Array.isArray(this.rows) ? this.rows : [];
            const name_and_number_data = [];
            rows.forEach((k, index) => {
                name_and_number_data[index] = Object.values(k || {});
            });

            let csv = this.csvHeader || "";
            name_and_number_data.forEach(function (row) {
                csv += row.join(",");
                csv += "\n";
            });

            const hiddenElement = document.createElement("a");
            hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
            hiddenElement.download = this.csvFileName || "NameAndNumber.csv";
            hiddenElement.click();
        }
    }
};
</script>

<style scoped>
.name-number-table-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex-wrap: wrap;
}

.data-export-btn {
    flex: 0 0 auto;
    order: 2;
}

.name-number-data {
    flex: 0 1 auto;
    order: 1;
}

.export-btn {
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    min-width: unset !important;
    width: auto !important;
}
</style>

